import React, { useContext } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { CurrentPage } from "../models/enums";
import { updateCriteriaModules } from "../routes/Search/search.ducks";
import ReactGA from "react-ga4";
import { Context } from "../GAContext";
import { SearchMode } from "../models/enums";
import styles from "../containers/HomePage/styles/SearchBar.scss";
import { StaticHTML } from "../components";

interface CategoryMatchSuggestionProps {
  displayText: string;
  url: string;
  searchText: string;
  clearCriteriaModules: any;
  setError: Function;
  setShowMobileStyle: Function;
  addRootScrollBar: Function;
  handleInputBlur: any;
  addRecentSearch?: Function;
}

function CategoryMatchSuggestion(props: CategoryMatchSuggestionProps) {
  const {
    displayText,
    url,
    searchText,
    clearCriteriaModules,
    setError,
    setShowMobileStyle,
    addRootScrollBar,
    handleInputBlur,
    addRecentSearch
  } = props;

  const highlightMatch = (text: string, query: string): string => {
    if (!query || query.trim().length < 3) return text;

    const words = query.trim().split(/\s+/).filter(word => word.length > 0);
    const escapedWords = words.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  };

  // Extract count from displayText (e.g., "Automobili (1,234)" -> 1234)
  const parseCountFromDisplayText = (text: string): number => {
    const match = text.match(/\(([0-9.,]+)\)/);
    if (match && match[1]) {
      return parseInt(match[1].replace(/[.,]/g, ''), 10) || 0;
    }
    return 0;
  };

  const [GaEvent] = useContext(Context);

  const handleClick = (e: React.MouseEvent) => {
    // GA event triggered by picking category match suggestion
    const label = {
      [CurrentPage.home]: "Odabir kategorijske pretrage - naslovna",
      [CurrentPage.search]: "Odabir kategorijske pretrage - rezultati pretrage",
      [CurrentPage.details]: "Odabir kategorijske pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Odabir kategorijske pretrage - moji oglasi",
      [CurrentPage.module]: "Odabir kategorijske pretrage  - stranica kategorije",
    }[GaEvent]

    if (GaEvent != "") {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label || ""
      });
      ReactGA.event({
        category: "Tekstualna pretraga",
        action: "Click",
        label: "Odabir ponuđene opcije kategorije - klasična"
      });
    }

    // GA4 event for tracking search terms (category navigation)
    ReactGA.event("view_search_results", {
      search_term: searchText.trim(),
      category: displayText || "",
      results_count: parseCountFromDisplayText(displayText),
      search_type: SearchMode.classic
    });

    if (addRecentSearch) {
      addRecentSearch(searchText, null, null, url.startsWith('/') ? url : `/${url}`);
    }

    handleInputBlur();
    clearCriteriaModules();
    setError(false);
    setShowMobileStyle(false);
    addRootScrollBar();
  };

  const trackingUrl = (() => {
    const base = url.startsWith('/') ? url : `/${url}`;
    const separator = base.includes("?") ? "&" : "?";
    return `${base}${separator}search_type=${SearchMode.classic}&search_query=${encodeURIComponent(searchText.trim())}`;
  })();

  return (
    <Link
      to={trackingUrl}
      className={styles.categoryMatchOption}
      onClick={handleClick}
    >
      <StaticHTML content={highlightMatch(displayText, searchText)} />
    </Link>
  );
}

function mapDispatchToProps(dispatch: any) {
  return {
    clearCriteriaModules: () => dispatch(updateCriteriaModules(null))
  };
}

export default connect(
  null,
  mapDispatchToProps
)(CategoryMatchSuggestion);



// WEBPACK FOOTER //
// ./src/utils/CategoryMatchSuggestion.tsx